"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const addActions = (actionsFetcher) => {
    return function (BaseClass) {
        return class extends BaseClass {
            constructor(...args) {
                super(...args);
                const actions = actionsFetcher(this);
                for (let action in actions) {
                    this[action] = mobx_1.action(actions[action]);
                }
            }
        };
    };
};
exports.addActions = addActions;
//# sourceMappingURL=add-actions.js.map